import { Redirect, Route } from "react-router-dom";

export const AdminRoute = ({ isAdmin, component: Comp, ...rest }) => {
  return (
    <Route
      {...rest}
      component={(props) =>
        isAdmin ? (
          <Comp {...props} />
        ) : (
          <Redirect to="/administration" {...props} />
        )
      }
    />
  );
};

export const AdminPublicRoute = ({
  isAdmin,
  restricted,
  component: Comp,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      component={(props) =>
        restricted ? (
          isAdmin ? (
            <Redirect to="/administration/dashboard" {...props} />
          ) : (
            <Comp {...props} />
          )
        ) : (
          <Comp {...props} />
        )
      }
    />
  );
};
